import { useState } from 'react'
import asterisk from '@/assets/loader/asterisk.svg'
import butterfly from '@/assets/loader/butterfly.svg'
import flower from '@/assets/loader/flower.svg'
import hourglassLine from '@/assets/loader/hourglass-line.svg'
import hourglass from '@/assets/loader/hourglass.svg'
import star from '@/assets/loader/star.svg'
import { cn } from '@/lib/utils'

/** Фирменные фигуры OA — по очереди сменяют друг друга в каждом лоадере. */
const SHAPES = [star, hourglass, asterisk, flower, butterfly, hourglassLine]

// Каждый новый лоадер начинает со следующей фигуры — рядом стоящие не одинаковые.
let nextStart = 0

interface Props {
  className?: string
}

/**
 * Фирменный лоадер: фигура проявляется, делает пол-оборота с разгоном и торможением,
 * замирает, ещё пол-оборота — и тает; следующая фигура проявляется на её месте
 * (смена происходит, пока фигуры не видно).
 * Цвета фигур — иллюстрация бренда, а не тема приложения.
 */
export const BrandLoader = ({ className }: Props) => {
  const [index, setIndex] = useState(() => nextStart++ % SHAPES.length)
  return (
    <img
      src={SHAPES[index]}
      alt=""
      aria-hidden="true"
      draggable={false}
      onAnimationIteration={() => setIndex((i) => (i + 1) % SHAPES.length)}
      className={cn('brand-flip size-14 object-contain', className)}
    />
  )
}
